'use client';

import CustomLink from 'components/shared/CustomLink';

export const hsaFsaFaqData = [
  {
    title: 'Can I claim for PowerPlugs such as Cardio Adaptability?',
    description: (
      <>
        Yes — Cardio Adaptability - 1 Year PowerPlug is eligible for HSA/FSA
        reimbursement.
      </>
    ),
  },
  {
    title: 'Do I need a Letter of Medical Necessity (LMN)?',
    description: (
      <>
        No, Ultrahuman Ring AIR, Cardio Adaptability - 1 Year PowerPlug and the
        Voyager Ring Charger are “always eligible” products – and don’t require
        a Letter of Medical Necessity (LMN). Pay via Flex—you’ll receive an
        itemized receipt from the payment processor. You can also use the
        invoice included in your order confirmation email, which serves as an
        itemized receipt.
      </>
    ),
  },
  {
    title: 'Can I purchase other Ultrahuman products with HSA/FSA?',
    description: (
      <>
        You can purchase the Voyager Ring Charger and Cardio Adaptability - 1
        Year PowerPlug as part of your HSA/FSA funds.
      </>
    ),
  },
  {
    title: 'Can I make a non-HSA/FSA payment and still claim the benefits?',
    description: (
      <>
        If you’ve already made a purchase via a payment method that is not
        “Flex” then you can still use your funds but will need an itemized
        receipt for reimbursement. Your order confirmation email includes an
        invoice that serves as an itemized receipt.
      </>
    ),
  },
  {
    title:
      'I keep being pushed to Shop Pay and can’t see Flex as a payment option.',
    description: (
      <>
        On the Checkout page, choose ‘Checkout as Guest’ option and you should
        see a full suite of payment options, including Flex. Or try the process
        in an incognito browser window.
      </>
    ),
  },
  {
    title: 'Why was my HSA/HSA card rejected?',
    description: (
      <>
        Check if there are sufficient funds in the account to complete the
        purchase – this is the most common issue. Also, ensure that all card
        details are correct and up to date.
      </>
    ),
  },
  {
    title: 'I have HSA/FSA but don’t have a card, can I still pay?',
    description: (
      <>
        Yes, you can buy your Ultrahuman Ring AIR and its add-ons and get a
        reimbursement. Your order confirmation email includes an invoice that
        serves as an itemized receipt.
      </>
    ),
  },
  {
    title: 'Who is the HSA/FSA partner of Ultrahuman?',
    description: (
      <>Flex has partnered with Ultrahuman for HSA/FSA card purchases.</>
    ),
  },
  {
    title: '',
    description: (
      <>
        Learn more from{' '}
        <CustomLink
          target="_blank"
          href="/blog/ultrahuman-ring-air-is-now-fsa-enabled/"
        >
          our blog
        </CustomLink>
        .
      </>
    ),
  },
];
